'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import { storeReferralCode } from './referral-storage'

/**
 * Invisible capturer of a `?ref=CODE` referral link (issue #71). Mounted once in
 * the marketing layout so it covers every entry a referred guest hits (landing,
 * /pricing, /signup); it stashes the code in the 14-day `kv_ref` cookie so it
 * survives the navigation + OTP/checkout round-trips that lose the query param.
 * The code is later read at guest checkout and signup-verify and sent to the
 * server, which captures the referral when the account is first created (and
 * only while the server-side `referral.enabled` kill-switch is on).
 *
 * Renders nothing. Must be wrapped in <Suspense> by the caller (Next requires it
 * for useSearchParams).
 */
export function ReferralCapture() {
  const searchParams = useSearchParams()
  const ref = searchParams.get('ref')

  useEffect(() => {
    if (ref) storeReferralCode(ref)
  }, [ref])

  return null
}
